import { createContext, useContext } from "react"

// Supplies the element ids a popup should portal into when it is rendered
// inside a modal that needs it to stay inside (see ModalMobile). Null outside
// such a modal, where popups keep their default portal targets.
export const ModalPortalContext = createContext(null)

export const useModalPortalIds = () => useContext(ModalPortalContext)

// The hosts sit in Silk's zero-height `overflow: auto` Island.Root, which
// Popper counts as a clipping parent even though the fixed hosts escape it.
// Left alone, flip measures against that box and won't open the calendar
// upward. An empty boundary clips to the viewport only.
export const MODAL_POPPER_MODIFIERS = [
  { name: "flip", options: { boundary: [] } },
  { name: "preventOverflow", options: { boundary: [] } },
]
